module.exports = __webpack_public_path__ + "assets/img/lector-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/lector-1.png
// module id = 1955
// module chunks = 0